import { useEffect, useRef, useState } from "react";
import "../css/navbar.css";
import logo from "../images/alphaconstructiontraining.png";
import { FaUserCircle } from "react-icons/fa";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true",
  );
  const navbarRef = useRef(null);
  const burgerRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Handle clicks outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target) &&
        burgerRef.current &&
        !burgerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Listen for login/logout changes across tabs or within app
  useEffect(() => {
    const handleStorageChange = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      setIsLoggedIn(loggedIn);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Custom event for same-tab login state updates
  useEffect(() => {
    const handleLoginStateChange = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      setIsLoggedIn(loggedIn);
    };

    window.addEventListener("loginStateChange", handleLoginStateChange);
    return () =>
      window.removeEventListener("loginStateChange", handleLoginStateChange);
  }, []);

  // Helper to log out user
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.setItem("isLoggedIn", "false");
    setIsLoggedIn(false);
    window.dispatchEvent(new Event("loginStateChange"));
    window.location.href = "/";
  };

  return (
    <nav className="navbar" ref={navbarRef}>
      <div className="logo-container">
        <a href="/">
          <img
            src={logo}
            alt="Alpha Construction Training Logo"
            className="logo"
            width={108}
            height={100}
          />
        </a>
      </div>

      <div className="navbar-right">
        <div className="burger-icon" ref={burgerRef} onClick={toggleMenu}>
          ☰
        </div>

        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          <a href="/cpcs">CPCS</a>
          <a href="/npors">NPORS</a>
          <a href="/nvq">NVQ</a>
          {/* <a href="/training">Training</a> */}
          <a href="/contactus">Contact Us</a>
        </div>

        {/* <div className="account-hover">
          <FaUserCircle className="account-icon" />
          <div className="account-hover-dropdown">
            {isLoggedIn ? (
              <>
                <a href="/account">My Account</a>
                <a href="/" onClick={handleLogout}>
                  Logout
                </a>
              </>
            ) : (
              <>
                <a href="/login">Login</a>
                <a href="/register">Register</a>
              </>
            )}
          </div>
        </div> */}
      </div>
    </nav>
  );
}
